import React from 'react'
import './productForm.scss'
import { useState } from 'react';
import Select from 'react-select';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../../config';
import Swal from 'sweetalert2';
import NdoeSpinner from '../../../components/ndoe/NdoeSpinner';
import { NdoeFormSection, NdoeActionButton } from '../../../components/ndoe';
import { useFormGuard } from '../../../utils/formGuard';
import { jourLocal } from '../../../utils/jourLocal';

const ProductForm = ({fetchData, closeOpen}) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
  const navigate = useNavigate();
  const [data, setData] = useState({})
  // Garde « formulaire modifié » (chevron retour / Back Android / beforeunload).
  useFormGuard(Boolean(data.nom_produit || data.id_categorie || data.id_marque));
  const [getCategorie, setGetCategorie] = useState([]);
  const [getMatiere, setGetMatiere] = useState([]);
  const [getMarque, setGetMarque] = useState();
  const [getCible, setGetCible] = useState([]);
  const [getEtatProduit, setGetEtatProduit] = useState("Actif");
  const [variantCheck, setVariantCheck] = useState([]);   // tableau (corrige le crash .some sur objet)
  const [dateEntrant, setDateEntrant] = useState(jourLocal());
  const [dateMiseAJour, setDateMiseAJour] = useState(jourLocal());
  const [variantExists, setVariantExists] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Aperçu de la nomenclature (CAT-MAR-XXXX) : le numéro de série naît à
  // l'enregistrement, l'aperçu montre le squelette dès que catégorie + marque
  // sont choisies. Lecture seule côté serveur, rien n'est réservé.
  const [nomenclature, setNomenclature] = useState(null);
  useEffect(() => {
    if (!data.id_categorie && !data.id_marque) { setNomenclature(null); return undefined; }
    let ok = true;
    axios.get(`${DOMAIN}/api/produit/nomenclature/apercu`, {
      params: { id_categorie: data.id_categorie, id_marque: data.id_marque },
    })
      .then(({ data: d }) => { if (ok) setNomenclature(d); })
      .catch(() => { if (ok) setNomenclature(null); });
    return () => { ok = false; };
  }, [data.id_categorie, data.id_marque, DOMAIN]);
  const handleInputChange = async (e) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    let updatedValue = fieldValue;

    if (fieldName === "image") {
      // ...
    } else if (fieldName === "contact_email") {
      updatedValue = fieldValue.toLowerCase();
    } else if (Number.isNaN(Number(fieldValue))) {
      updatedValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);
    } else if (fieldName === "date_entrant") {
      // Mettre à jour la valeur par défaut de "Date d'entrée" avec la valeur modifiée
      setDateEntrant(fieldValue);
    } else if (fieldName === "date_MisAjour") {
      // Mettre à jour la valeur par défaut de "Date de mise à jour" avec la valeur modifiée
      setDateMiseAJour(fieldValue);
     }

     // Vérifier si la variante existe déjà (garde : variantCheck peut être vide/non chargé)
     if (fieldName === "code_variante") {
      const exists = Array.isArray(variantCheck) && variantCheck.some(
        (variant) => variant.code_variante?.toLowerCase() === fieldValue.toLowerCase()
      );
      setVariantExists(exists);
    }

    setData((prev) => ({ ...prev, [fieldName]: updatedValue }));
  };

  const handleInputChange1 = async (e) => {
    setGetEtatProduit( e.target.value );
  };

  useEffect(() => {
    const fetchCategorie = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/categorie`);
        setGetCategorie(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCategorie();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchMatiere = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/matiere`);
        setGetMatiere(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchMatiere();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchMarque = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/marque`);
        setGetMarque(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchMarque();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchCible = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/cible`);
        setGetCible(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCible();
  }, [DOMAIN]);

  useEffect(() => {
    const fetchVariantCheck = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/produit/CodevarianteProduit`);
        setVariantCheck(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchVariantCheck();
  }, [DOMAIN]);


  const handleClick = async (e) => {
    e.preventDefault();

    if (!data.nom_produit || !data.id_categorie || !data.id_marque || !data.id_matiere || !data.prix || !data.code_variante || !getEtatProduit) {
      Swal.fire({
        title: 'Error',
        text: 'Veuillez remplir tous les champs requis',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }

    // Anti-récidive (18/07) : si un modèle de même nom + marque existe déjà, on
    // AVERTIT (sans bloquer) — c'est ainsi que le doublon ESO-ASO-0597/0610 est né.
    try {
      const { data: dup } = await axios.get(`${DOMAIN}/api/fusion/verifier`, {
        params: { nom: data.nom_produit, id_marque: data.id_marque },
      });
      if (Array.isArray(dup?.existants) && dup.existants.length > 0) {
        const liste = dup.existants.map((p) => `• ${p.code_produit} — ${p.nom_produit}`).join('<br>');
        const r = await Swal.fire({
          title: 'Ce modèle existe peut-être déjà',
          html: `Une fiche au même nom et à la même marque existe :<br><br>${liste}<br><br>Créer quand même une nouvelle fiche ?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Créer quand même',
          cancelButtonText: 'Annuler',
        });
        if (!r.isConfirmed) return;
      }
    } catch (_) { /* la vérif ne doit jamais bloquer la création */ }

    try{
      setIsLoading(true);
      await axios.post(`${DOMAIN}/api/produit/produit`, {...data, date_entrant: dateEntrant, date_MisAjour: dateMiseAJour, etatProduit: getEtatProduit})
      Swal.fire({
        title: 'Success',
        text: 'Produit créé avec succès!',
        icon: 'success',
        confirmButtonText: 'OK',
      });

      fetchData?.();
      // Mode page (/productForm, sans props) : retour à la liste des produits.
      if (closeOpen) closeOpen(); else navigate('/products');
      setData({});
      setDateEntrant(jourLocal());
      setDateMiseAJour(jourLocal());
      setGetEtatProduit("Actif");
      setVariantExists(false);
    }catch(err) {
      Swal.fire({
        title: 'Error',
        text: err.message,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="productForm">
      <div style={{ marginBottom: 14 }}>
        <div className="ndoe-eyebrow">Catalogue</div>
        <h2 className="ndoe-page-title" style={{ fontSize: 20 }}>Ajouter un produit</h2>
        <p className="ndoe-page-subtitle">Créer un nouveau produit</p>
      </div>

      <NdoeFormSection step={1} title="Identité du produit" hint="Nom, catégorie, marque, matière, cible" collapsible={false}>
        <div className="ndoe-form-grid">
          <div className="form-controle ndoe-form-grid--full">
            <label>Nom du produit <span style={{color:'red'}}>*</span></label>
            <input 
              type="text" 
              value={data?.nom_produit || ''} 
              name='nom_produit' 
              className="form-input" 
              placeholder='Entrer le nom...' 
              onChange={handleInputChange} 
              style={{border:'none', outline:'none', padding: '8px 10px', width:'100%', border:'1px solid #c5c5c5', borderRadius:'5px'}}
              />
          </div>
          <div className="form-controle">
            <label>Catégorie <span style={{color:'red'}}>*</span></label>
            <Select
                name="id_categorie"
                value={data?.id_categorie ? { value : data.id_categorie, label : getCategorie.find(cat => cat.id_categorie === data.id_categorie)?.nom_categorie} : null}
                options={getCategorie?.map(item => ({ value: item.id_categorie, label: item.nom_categorie }))}
                onChange={selectedOption => handleInputChange({ target: { name: 'id_categorie', value: selectedOption.value } })}
              />
          </div>
          <div className="form-controle">
            <label>Marque <span style={{color:'red'}}>*</span></label>
            <Select
              name="id_marque"
              value={data.id_marque ? { value : data.id_marque, label: getMarque?.find(marque => marque.id_marque === data.id_marque)?.nom} : null}
              options={getMarque?.map(item => ({ value: item.id_marque, label: item.nom }))}
              onChange={selectedOption => handleInputChange({ target: { name: 'id_marque', value: selectedOption.value } })}
            />
          </div>
          {nomenclature && (
            <div className="form-controle">
              <label style={{ color: '#8a93a3' }}>Référence produit (attribuée à l'enregistrement)</label>
              <input
                type="text"
                className="form-input"
                value={nomenclature.apercu}
                disabled
                style={{ background: '#f5f2ea', color: '#8a93a3', fontVariantNumeric: 'tabular-nums', letterSpacing: '0.04em', cursor: 'not-allowed' }}
              />
            </div>
          )}
          <div className="form-controle">
            <label>Matière <span style={{color:'red'}}>*</span></label>
            <Select
              name="id_matiere"
              value={
                data.id_matiere
                  ? {
                      value: data.id_matiere,
                      label: getMatiere.find(
                        matiere => matiere.id_matiere === data.id_matiere
                      )?.nom_matiere
                    }
                  : null
              }
              options={getMatiere?.map(item => ({
                value: item.id_matiere,
                label: item.nom_matiere
              }))}
              onChange={selectedOption =>
                handleInputChange({
                  target: {
                    name: "id_matiere",
                    value: selectedOption.value
                  }
                })
              }
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({
                  ...base,
                  zIndex: 99999
                }),
                menu: base => ({
                  ...base,
                  zIndex: 99999
                })
              }}
            />
          </div>
          <div className="form-controle">
            <label>Cible <span style={{color:'red'}}>*</span></label>
            <Select
              name="id_cible"
              value={
                data.id_cible
                  ? {
                      value: data.id_cible,
                      label: getCible.find(
                        cible => cible.id_cible === data.id_cible
                      )?.nom_cible
                    }
                  : null
              }
              options={getCible?.map(item => ({
                value: item.id_cible,
                label: item.nom_cible
              }))}
              onChange={selectedOption =>
                handleInputChange({
                  target: {
                    name: 'id_cible',
                    value: selectedOption.value
                  }
                })
              }
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999
                }),
                menu: base => ({
                  ...base,
                  zIndex: 9999
                })
              }}
            />
          </div>
        </div>
      </NdoeFormSection>

      <NdoeFormSection step={2} title="Prix & référence" hint="Prix, code variante, dates" collapsible={false}>
        <div className="ndoe-form-grid">
          <div className="form-controle">
            <label>Prix <span style={{color:'red'}}>*</span></label>
            <input 
              type="number" 
              value={data?.prix || ''} 
              name='prix' 
              placeholder='ex: 10$' 
              className="form-input" 
              onChange={handleInputChange} 
              style={{border:'none', outline:'none', padding: '8px 10px', width:'100%', border:'1px solid #c5c5c5', borderRadius:'5px'}}
            />
          </div>
          <div className="form-controle">
            <label>Code variant <span style={{color:'red'}}>*</span></label>
            <input 
              type="text" 
              value={data?.code_variante || ''} 
              name='code_variante' 
              placeholder='ex: P329' 
              className="form-input" 
              onChange={handleInputChange} 
              style={{border:'none', outline:'none', padding: '8px 10px', width:'100%', border:'1px solid #c5c5c5', borderRadius:'5px'}}
              />
            {variantExists && <p className="error-message" style={{color:"red", fontSize:"13px"}}>Cette variante existe déjà.</p>}
          </div>
          <div className="form-controle">
            <label>Date d'entrant <span style={{color:'red'}}>*</span></label>
            <input 
            type="date" 
            name='date_entrant' 
            value={dateEntrant} 
            onChange={handleInputChange} 
            className="form-input" 
            style={{border:'none', outline:'none', padding: '8px 10px', width:'100%', border:'1px solid #c5c5c5', borderRadius:'5px'}}
            />
          </div>
          <div className="form-controle">
            <label>Date de mis à jour <span style={{color:'red'}}>*</span></label>
            <input 
            type="date" 
            name='date_MisAjour' 
            value={dateMiseAJour} 
            onChange={handleInputChange} 
            className="form-input" 
            style={{border:'none', outline:'none', padding: '8px 10px', width:'100%', border:'1px solid #c5c5c5', borderRadius:'5px'}}
            />
          </div>
        </div>
      </NdoeFormSection>

      <NdoeFormSection step={3} title="État du produit" collapsible={false}>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          <div className='form-radio'>
            <input type="radio" id="Actif" name="etatProduit" value="Actif" checked={getEtatProduit === 'Actif'} onChange={handleInputChange1}/>
            <label htmlFor="Actif">Actif</label>
          </div>
          <div className='form-radio'>
            <input type="radio" id="Passif" name="etatProduit" value="Passif" checked={getEtatProduit === 'Passif'} onChange={handleInputChange1}/>
            <label htmlFor="Passif">Passif</label>
          </div>
        </div>
      </NdoeFormSection>

      <div style={{ display: 'flex', gap: 10, marginTop: 16, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <NdoeActionButton variant="secondary" onClick={() => (closeOpen ? closeOpen() : navigate(-1))}>Annuler</NdoeActionButton>
        <NdoeActionButton
          variant="primary"
          onClick={handleClick}
          loading={isLoading}
          icon={isLoading ? <NdoeSpinner size={16} /> : null}
        >
          Soumettre
        </NdoeActionButton>
      </div>
    </div>
  )
}

export default ProductForm
